export default __webpack_public_path__ + "static/media/kanban_board.07b02dfa.svg";